module.exports = __webpack_public_path__ + "c3390becc9029b5bd49a4d6358afbe24.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/image/ic_push-notification.svg
// module id = 1175
// module chunks = 0